<template>
    <div>
        <!-- Corps -------------------------------------------------------------------------------->          
        <div class="divTable">
      <!-- Titre du sous menu -->
      <div  class="divCellLeft hidden-xs-only colorS">
        <div class="rotate">{{column.leftTitle}}</div>
      </div>
      <div   class="divCellTop hidden-sm-and-up">
        <div class="border-r colorS" >{{column.leftTitle}}</div>
      </div>

      <!--  -->
      <div  class="divCell colorS-td border-l" >
        <el-row ><el-col v-for="(value,index) in column.col01" :key="index" :md="8" :sm="12" :xs="24">
                <checkup-detail v-bind:checkupDetail="value" />
        </el-col></el-row >
      </div>
    </div>
       
    </div>
</template>

<script>

import CheckupDetail from '@/components/checkup.detail.component.vue'

export default {
  name: 'CheckepPart3',
  props: ['column'],
  components: {
      CheckupDetail
  },
  

  computed: {
		backgroundColor() {
			return this.parameters.classColor;
		},
      backgroundColorTd() {
        return this.parameters.classColor+"-td";
      }
  },
  data() {
    return {
        parameters:{
            classColor: "colorS",
            borderLeft : "",
            borderRight : "" 
        }
    };
  }
};
</script>

<style scoped>
 @media only screen and (max-width: 767px) {   
    .border-l{
      border-left-style: none;
    }
.border-r{
      border-right-style: none;
      border-bottom-width: 6px;
      border-bottom-style: solid;
      border-color: white;
    }

  }
</style>